/** Total due for a membership row (package + fees − discount). */
export function membershipTotalAmount(row) {
  const packageFee = Number(row?.packageFee) || 0;
  const registrationFee = Number(row?.registrationFee) || 0;
  const discount = Number(row?.discountAmount) || 0;
  const pt = Number(row?.personalTrainingFee) || 0;
  const classes = Number(row?.classesFee) || 0;
  return Math.max(0, packageFee - discount + registrationFee + pt + classes);
}

export function membershipPendingAmount(row) {
  const total = membershipTotalAmount(row);
  const paid = Number(row?.totalPaid) || 0;
  const computed = Math.max(0, Math.round((total - paid) * 100) / 100);
  // Prefer live total − paid (do not trust stored 0 when fees were backfilled)
  if (total > 0 || paid > 0) return computed;
  const pending = Number(row?.pendingAmount);
  if (Number.isFinite(pending) && pending > 0) return pending;
  return 0;
}

export function membershipCanPayBalance(row) {
  return membershipPendingAmount(row) > 0 && Boolean(row?.paymentDbId);
}
